<script setup>
defineProps({ modelValue: String, rows: { type: [String, Number], default: 4 }, placeholder: String })
const emit = defineEmits(["update:modelValue"])
</script>

<template>
  <textarea
    class="textarea"
    :rows="rows"
    :placeholder="placeholder"
    :value="modelValue"
    @input="emit('update:modelValue', $event.target.value)"
  />
</template>
